import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/StudentCard.css';

const StudentCard = ({ student }) => {
    const navigate = useNavigate();

    if (!student) return null; 

    const handleViewMore = () => {
        navigate(`/student/${student._id}`);
    };

    return (
        <div className="student-card">
            <div className="student-card-header">
                <div className="student-profile-pic">
                    <img src={student.profile_image} alt="Profile" />
                </div>
                <button onClick={handleViewMore} className="view-more-btn">{'>'} View More</button>
            </div>
            <div className="student-info">
                <h3>{student.first_name} {student.last_name}</h3>
                <p><strong>Grade:</strong> {student.grade}</p>
                <p><strong>Experience With:</strong> {student.list_of_trained_tools.map(tool => tool.tool_name).join(', ')} 
                {student.list_of_trained_tools.length === 0 && <span>No tools trained yet.</span>}</p>
            </div>
        </div>
    );
};

export default StudentCard;

